module.exports = __webpack_public_path__ + "img/selected4-min.f8863edd.png";